<template>
    <div class="w-full md:w-4/5 m-auto py-6 px-12">
        <div v-if="loading" class="lds-spinner">
            <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
        </div>
        <h1 class="mb-4 text-green-600 text-2xl text-left font-bold text-2xl">Your offer</h1>
        <div class=" flex flex-wrap bg-gray-100 border px-4 py-1 mt-1 pb-6">
            <span v-if="recordedDecision !== ''" class="mt-2"><router-link :to="{ name: 'ViewApplication' }">Return to dashboard</router-link></span>
            <div class="w-full text-left relative flex flex-wrap">
                <h2>{{ application['programmeName'] + ', ' }} {{ application['programmeType'] }}</h2>
            </div>
            <div class="w-full text-left relative flex flex-wrap">
                <div v-if="recordedDecision === 'Offer Accepted' || recordedDecision === 'Awaiting Deposit'">
                    <div v-if="application['depositRequired'] === 1">
                        <div v-if="application['depositPaid'] === 1">
                            <p>Your decision to <strong>accept</strong> the offer has been recorded and your deposit has been paid</p>
                        </div>
                        <div v-else>
                            <p>Your decision to <strong>accept</strong> the offer has been recorded, pending the payment of a deposit</p>
                            <div v-if="application['depositPaymentStatus'] === 'PROCESSING'" class="py-4">
                                <strong>Your payment is underway with Flywire.</strong> We are checking the payment status every 30 seconds
                                <p class="py-2">Should you need it again, the payment link is:</p>
                                <div v-if="paymentLink.length > 0">
                                    <a target="_blank" :href="paymentLink">{{ paymentLink }}</a>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="paymentLink.length > 0" class="">
                                    <a :href="paymentLink" target="_blank"
                                       class="btn-green bg-green-400 items-center text-white inline-block" @click="setInterval"
                                    >Begin deposit payment with Flywire</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p>Your decision to <strong>accept</strong> the offer has been recorded</p>
                    </div>
                </div>
                <div v-else-if="recordedDecision.includes('Offer Declined')" class="-mb-6 pb-5">
                    <p>Your decision to <strong>decline</strong> the offer has been recorded</p>
                </div>
                <div v-else>
                    <p>Please carefully read the terms and conditions below before making your decision</p>
                </div>

                <div v-if="recordedDecision !== '' && !recordedDecision.includes('Offer Declined')" class="w-full text-left relative flex flex-wrap mb-2 mt-2">
                    <button class="btn-green mt-4" @click="showTerms = !showTerms"><span v-if="!showTerms">Show</span><span v-else>Hide</span> Terms and Conditions</button>
                </div>

                <terms v-if="application['offerTerms'] && showTerms" :terms="application['offerTerms']"
                       class="w-full overflow-y-scroll h-96 border-solid border-black"
                />
            </div>
            <div v-if="recordedDecision === ''" class="w-full">
                <div class="pb-4 relative text-center">
                    <p>I would like to...</p>
                    <div class="">
                        <div class="md:inline-block px-8">
                            <input id="accept-option" v-model="userDecision" type="radio" value="Accept" class="" />
                            <label for="accept-option" class="ml-2"><strong>Accept the offer</strong></label>
                        </div>
                        <div class="md:inline-block px-8">
                            <input id="decline-option" v-model="userDecision" type="radio" value="Decline" class="" />
                            <label for="decline-option" class="ml-2"><strong>Decline the offer</strong></label>
                        </div>
                    </div>
                </div>
                <div v-if="userDecision === 'Accept' || userDecision === 'Decline'" class="w-full relative text-center">
                    <p v-if="userDecision === 'Accept'" class="">I agree to the Terms and Conditions of Admission</p>
                    <div v-if="userDecision === 'Decline'" class="">
                        <p>Can you please let us know your reason for declining?</p>
                        <select id="rejection_reason" v-model="rejectionReason" label="Please choose a reason for the rejection" class="p-3 mb-5">
                            <option v-for="(name, reference) in application.attachedLists?.application_offer_decline_reasons?.values" :key="reference" :value="reference" class="p-3">{{ name }}</option>
                        </select>
                    </div>
                    <button class="btn-green" @click="submitDecision">
                        Submit my decision now
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Terms from '@/views/Application/Details/Terms'

export default {
    name: 'Application',
    metaInfo() {
        return {
            title: 'Application',
        }
    },
    components: {
        Terms,
    },
    data() {
        return {
            status: String,
            loading: true,
            userDecision: String,
            rejectionReason: String,
            recordedDecision: String,
            showTerms: true,
            applicationReference: '',
            paymentLink: '',
            paymentType: 'deposit',
            application: {
                reference: '',
                status: '',
                academicYear: '',
                programmeType: '',
                programmeName: '',
            },
            depositPaymentStatus: '',
        }
    },
    computed: {
        applicationDetails() {
            return this.$store.getters.applicationDetails
        },
    },
    watch: {
        application() {
            this.recordedDecision = this.application['userDecision'] ?? ''

            if (this.recordedDecision !== '')
            {
                if (this.recordedDecision === 'Offer Accepted' && this.application['status'] === 'Awaiting Deposit')
                {
                    this.recordedDecision = 'Awaiting Deposit'
                }
                this.showTerms = false
            }
            this.hasLoaded()
        },
    },
    created() {

    },
    mounted() {
        this.applicationReference = this.$route.params.id
        this.$nextTick(function () {
            this.getApplicationInfo()
            this.getLink()
        })

    },
    methods: {
        clearInterval() {
            clearInterval(this.interval)
        },
        setInterval() {
            setTimeout(() => {
                this.application['depositPaymentStatus'] = 'PROCESSING'
                this.checkPaymentStatus()
            }, 2000)

            this.interval = setInterval(() => {
                this.checkPaymentStatus()
            },30000)
        },
        checkPaymentStatus() {
            this.$store.dispatch('checkPaymentStatus', {
                applicationRef: this.applicationReference,
                paymentType: this.paymentType,
            })
                .then(response => {
                    if (response.data === '1')
                    {
                        this.application['depositPaymentStatus'] = 'COMPLETED'
                        this.application['depositPaid'] = 1
                        clearInterval(this.interval)
                    }
                })
                .catch(() => {
                    clearInterval(this.interval)
                })
        },
        getLink() {
            this.$store.dispatch('getPaymentLink', {
                applicationRef: this.applicationReference,
                paymentType: this.paymentType,
            })
                .then((response) => {
                    this.paymentLink = response.data
                })
                .catch(() => {
                    this.paymentLink = ''
                })
        },
        getApplicationInfo()
        {
            this.$store.dispatch('getBasicApplicationInfo', {
                applicationRef: this.applicationReference,
            })
                .then((response) => {
                    this.application = response.data
                    if (this.application['depositRequired'] === 1 && this.application['depositPaid'] === 0)
                    {
                        if (this.application['depositPaymentStatus'] === 'PENDING' || this.application['depositPaymentStatus'] === 'PROCESSING')
                        {
                            this.setInterval()
                        }
                    }

                    this.hasLoaded()
                })
                .catch(() => {
                    this.application = []
                })

        },
        redirect(status) {
            if (status !== null && typeof status === 'string') {
                switch (status) {
                    case 'Offered':
                    case 'Offered, Registry Review (on hold)':
                    case 'Awaiting Deposit':
                    case 'Offer Accepted':
                    case 'Offer Accepted - awaiting invoice':
                    case 'Offer Accepted - invoice sent':
                    case 'Offer Accepted - paid':
                    case 'Offer Accepted (sponsored)':
                    case 'Offer Declined':
                    case 'Offer Declined (self-funded)':
                    case 'Offer Declined (sponsored)':
                        break
                    default:
                        this.$router.push('/applications')
                        break
                }
            }
        },
        submitDecision() {
            if (confirm('Are you sure you want to submit your decision?')) {
                this.loading = true

                if (this.userDecision === 'Accept' || this.userDecision === 'Decline') {
                    this.$store.dispatch('recordDecision', {
                        userDecision: this.userDecision,
                        rejectionReason: this.rejectionReason,
                        reference: this.application['reference'],
                    })
                        .then((response) => {
                            this.loading = false
                            this.serverErrors = ''
                            this.recordedDecision = response.data
                            this.formDirty = false
                            this.showTerms = false
                        })
                        .catch(error => {
                            this.loading = false
                            this.successMessage = ''
                            this.formDirty = false
                        })
                }
            }
        },
        hasLoaded() {
            this.redirect(this.application['status'])
            this.loading = false
        },
    },
}
</script>
<style scoped>
:deep() p {
    margin: 16px 0 16px !important;
}

:deep() h2 {
    margin: 19px 0 0 !important;
    font-weight: bolder;
}
</style>
